<template>
    <administrative>
        <form form @submit.prevent="submitForm">
            <div class="flex">
                <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg w-full">
                    <loading :showLoading="form.processing"/>
                    <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">

                        <div class="grid grid-cols-2 gap-4 mb-4">
                            <p class="text-lg font-medium col-span-2">Staff Details</p>
                            <div class="">
                                <breeze-label :required="true" :value="'Name'"/>
                                <breeze-input required v-model="form.name" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.name:''"/>
                            </div>

                            <div class="">
                                <breeze-label :required="true" :value="'Mobile'"/>
                                <breeze-input required type="number" v-model="form.mobile" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.mobile:''"/>
                            </div>

                            <div class="">
                                <breeze-label :required="true" :value="'Email'"/>
                                <breeze-input required v-model="form.email" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.email:''"/>
                            </div>

                            <div class="">
                                <breeze-label :value="'Date Of Birth'"/>
                                <breeze-input v-model="form.date_of_birth" type="date" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.date_of_birth:''"
                                />
                            </div>

                            <div class="">
                                <breeze-label :value="'Blood Group'"/>
                                <breeze-input v-model="form.blood_group" type="text" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.blood_group:''"
                                />
                            </div>

                            <!--                            <div class="col-span-2 sm:col-span-2">-->
                            <!--                                &lt;!&ndash; <breeze-label :value="'Photo'"/> &ndash;&gt;-->
                            <!--                                <input type="file" class="" ref="photo" @change="updatePhotoPreview"-->
                            <!--                                       accept=".png, .jpg, .jpeg, .webp"/>-->
                            <!--                                <div v-show="! photoPreview">-->
                            <!--                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-24 w-24" viewBox="0 0 20 20"-->
                            <!--                                         fill="currentColor">-->
                            <!--                                        <path fill-rule="evenodd"-->
                            <!--                                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"-->
                            <!--                                              clip-rule="evenodd"/>-->
                            <!--                                    </svg>-->
                            <!--                                </div>-->
                            <!--                                <div class="mt-2" v-show="photoPreview">-->
                            <!--                                <span class="block rounded-full w-20 h-20"-->
                            <!--                                      :style="'background-size: cover; background-repeat: no-repeat; background-position: center center; background-image: url(\'' + photoPreview + '\');'">-->
                            <!--                                </span>-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                            <div class="grid grid-cols-2">

                                <ProfileImageComponent required v-model="form.profile"
                                                       :error-message="form.errors?.profile"
                                                       :old-image="staff?.profile"/>
                            </div>

                        </div>

                        <exception/>

                    </div>
                </div>
            </div>

            <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg mt-4">
                <div class="grid grid-cols-3 gap-4 mb-4">
                    <p class="text-lg font-medium col-span-3">Bank Details</p>
                    <div class="">
                        <breeze-label :required="true" :value="'Account Name'"/>
                        <breeze-input required v-model="form.account_name" class="w-full"/>
                        <breeze-input-error :message="form.errors?form.errors.account_name:''"/>
                    </div>
                    <div class="">
                        <breeze-label :required="true" :value="'Bank Name'"/>
                        <breeze-input required v-model="form.bank_name" class="w-full"/>
                        <breeze-input-error :message="form.errors?form.errors.bank_name:''"/>
                    </div>
                    <div class="">
                        <breeze-label :required="true" :value="'Bank Branch'"/>
                        <breeze-input required v-model="form.bank_branch" class="w-full"/>
                        <breeze-input-error :message="form.errors?form.errors.bank_branch:''"/>
                    </div>
                    <div class="">
                        <breeze-label :required="true" :value="'Account No'"/>
                        <breeze-input required v-model="form.account_no" type="number" class="w-full"/>
                        <breeze-input-error :message="form.errors?form.errors.account_no:''"/>
                    </div>
                    <div class="">
                        <breeze-label :required="true" :value="'IFSC Code'"/>
                        <breeze-input required v-model="form.ifsc_code" class="w-full"/>
                        <breeze-input-error :message="form.errors?form.errors.ifsc_code:''"/>
                    </div>
                </div>
            </div>

            <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg mt-4">

                <div class="grid gap-4 mb-4">
                    <div>
                        <FormMultiselect
                            required
                            label="Select Documents type"
                            :options="docOptions"
                            track-key="id"
                            label-key="title"
                            :object="true"
                            mode="tags"
                            v-model="form.documents"
                            :placeholder="'Select Semester Type'"
                            :error="form.errors.documents"
                        />
                    </div>
                    <div>
                        <p class="text-lg font-medium">Staff Documents</p>
                        <p>Document up to 2MB</p>
                    </div>

                    <div class="flex items-center" v-for="(item,index) in form.documents" :key="index">
                        <div>
                            <breeze-label :required="true" :value="`Select ${item.title}`"/>
                            <input class="mt-2" @change="(e)=>selectFile(e,index)" type="file"
                                   accept=".png, .jpg, .jpeg, .pdf" placeholder="Select File"/>
                            <breeze-input-error
                                :message="form.errors?.[`documents.${index}.file`]==`The documents.${index}.file failed to upload.`?`The file size must be 2 MB or less.`:form.errors?.[`documents.${index}.file`]"/>
                        </div>
                        <div v-if="item.file_link">
                            <a class=" w-full inline-flex items-center px-4 py-2
                     bg-gray-800 border border-transparent rounded-md
                      font-semibold text-xs text-white uppercase tracking-widest
                      hover:bg-gray-700 active:bg-gray-900 focus:outline-none
                      focus:border-gray-900 focus:shadow-outline-gray
                      transition ease-in-out duration-150 justify-center text-nowrap"
                               :href="item.file_link" target="_blank">View Document</a>
                        </div>
                    </div>

                </div>

            </div>
            <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg mt-4">
                <button-link
                    :href="route('administrative.staff.list')"
                    class="bg-red-500 mr-4 hover:bg-red-400"
                >Cancel
                </button-link>
                <!--                :disabled="form.processing"-->
                <breeze-button :disabled="form.processing">Update</breeze-button>

                <button-link class="ml-4"
                             :href="route('administrative.staff.generate.id',staff.id)">generate id Card
                </button-link>
            </div>
            <div class="w-full grid grid-cols-6 gap-3 mt-6">
                <div v-for="branch in (staff?.staff_branch??[]).filter((item)=>item.id_card)" :key="branch.id">
                    <img :src="branch.id_card" alt="Id card" class="w-full"/>
                    <breeze-button class="!w-full !rounded-none text-center" @click="downloadSource(branch.id_card)"
                                   type="button">Download Id Card
                    </breeze-button>
                </div>
            </div>
        </form>
    </administrative>
</template>

<script setup>
import Administrative from "@/Pages/Administrative/Administrative";
import BreezeInput from "@/Components/Input";
import BreezeLabel from "@/Components/Label";
import BreezeInputError from "@/Components/InputError";
import BreezeButton from "@/Components/Button";
import ButtonLink from "@/Components/ButtonLink";
import Exception from "@/Components/Exception";
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import Loading from "@/Components/Loading";
import {onMounted, ref, computed} from "vue";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import InputError from "@/Components/InputError.vue";
import ProfileImageComponent from "@/Components/ProfileImageComponent.vue";

const props = defineProps({
    staff: Object
});
const photoPreview = ref(props?.staff?.profile ?? '');
const errors = computed(() => usePage().props.value?.errors ?? []);
const photo = ref('');
const docOptions = ref([
    {id: 1, title: 'Aaadhar Card'},
    {id: 2, title: 'Pan Card'},
    {id: 3, title: 'Passbook'},
    {id: 4, title: 'Checkbook'},
])
const form = useForm({
    name: props.staff?.name,
    mobile: props.staff?.mobile,
    email: props.staff?.email,
    blood_group: props.staff?.blood_group,
    date_of_birth: props.staff?.date_of_birth,
    account_name: props.staff?.account_name,
    bank_name: props.staff?.bank_name,
    bank_branch: props.staff?.bank_branch,
    account_no: props.staff?.account_no,
    ifsc_code: props.staff?.ifsc_code,
    profile: '',
    documents: props.staff?.documents ?? [],
});

onMounted(() => {
    docOptions.value = docOptions.value.map((item) => {
        let _item = (props.staff?.documents ?? []).find((_i) => _i.id == item.id);
        if (_item) {
            return _item;
        } else {
            return item;
        }

    })
})

function submitForm() {
    form.post(route("administrative.staff.update", props.staff.id), {
        preserveScroll: true,
        preserveState:true,
        onSuccess: () => {
            form.reset();
        }
    });
}

function selectNewPhoto() {
    if (photo.value) {
        photo.value.click();
    }
}

function updatePhotoPreview(e) {
    var data = e.target.files || e.dataTransfer.files;
    if (!data.length) return;
    form.profile = data[0];
    photoPreview.value = URL.createObjectURL(data[0]);
}

const selectFile = (e, index) => {
    let data = e.target.files || e.dataTransfer.files;
    form.documents[index].file = data[0];
}

function downloadSource(source) {
    const fileName = source.split('/').pop();
    var el = document.createElement("a");
    el.setAttribute("href", source);
    el.setAttribute("download", fileName);
    document.body.appendChild(el);
    el.click();
    el.remove();
}

const deletePhoto = () => {
    photoPreview.value = null;
}

</script>
